module.exports = __webpack_public_path__ + "static/media/edit_payment.3e75b77b.svg";